<template>
  <div class="bjex-main" v-loading="loading">
    <div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="整本书" name="book"></el-tab-pane>
        <el-tab-pane label="系列阅读" name="package"></el-tab-pane>
      </el-tabs>
    </div>
    <div>
      <el-form label-width="80px" v-if="activeName == 'book'">
        <el-form-item label="图书状态:">
          <el-button type="text" @click=";(publishStatus = ''), queryBookList()" :class="publishStatus === '' ? '' : 'yanse'">全部</el-button>
          <el-button type="text" @click=";(publishStatus = 0), queryBookList()" :class="publishStatus === 0 ? '' : 'yanse'">未发布</el-button>
          <el-button type="text" @click=";(publishStatus = 1), queryBookList()" :class="publishStatus === 1 ? '' : 'yanse'">已发布</el-button>
        </el-form-item>
        <el-form-item label="适合年级:">
          <el-button type="text" @click=";(gradeId = ''), queryBookList()" :class="gradeId == '' ? '' : 'yanse'">全部</el-button>
          <el-button type="text" @click=";(gradeId = item.gradeId), queryBookList()" :class="item.gradeId == gradeId ? '' : 'yanse'" v-for="item in gradelist" :key="item.gradeId">{{
            item.name
          }}</el-button>
        </el-form-item>
        <el-form-item label="所属专栏:">
          <el-button type="text" @click=";(specialId = ''), queryBookList()" :class="specialId == '' ? '' : 'yanse'">全部</el-button>
          <el-button type="text" @click=";(specialId = item.code), queryBookList()" :class="item.code == specialId ? '' : 'yanse'" v-for="item in specialColumn" :key="item.code">{{
            item.name
          }}</el-button>
        </el-form-item>
        <el-form-item label="图书来源:">
          <!-- <el-button type="text" @click=";(bookSourceType = ''), queryBookList()" :class="specialId == '' ? '' : 'yanse'">全部</el-button> -->
          <el-button type="text" @click=";(bookSourceType = 0), queryBookList()" :class="0 == bookSourceType ? '' : 'yanse'">平台创建</el-button>
          <el-button type="text" @click=";(bookSourceType = 1), queryBookList()" :class="1 == bookSourceType ? '' : 'yanse'">本校创建</el-button>
        </el-form-item>
      </el-form>
      <el-form label-width="80px" v-if="activeName == 'package'">
        <el-form-item label="图书状态:">
          <el-button type="text" @click=";(publishStatus = ''), queryBillList()" :class="publishStatus === '' ? '' : 'yanse'">全部</el-button>
          <el-button type="text" @click=";(publishStatus = 0), queryBillList()" :class="publishStatus === 0 ? '' : 'yanse'">未发布</el-button>
          <el-button type="text" @click=";(publishStatus = 1), queryBillList()" :class="publishStatus === 1 ? '' : 'yanse'">已发布</el-button>
        </el-form-item>
        <el-form-item label="适合年级:">
          <el-button type="text" @click=";(gradeId = ''), queryBillList()" :class="gradeId == '' ? '' : 'yanse'">全部</el-button>
          <el-button type="text" @click=";(gradeId = item.gradeId), queryBookList()" :class="item.gradeId == gradeId ? '' : 'yanse'" v-for="item in gradelist" :key="item.gradeId">{{
            item.name
          }}</el-button>
        </el-form-item>
        <el-form-item label="所属专栏:">
          <el-button type="text" @click=";(specialId = ''), queryBillList()" :class="specialId == '' ? '' : 'yanse'">全部</el-button>
          <el-button type="text" @click=";(specialId = item.code), queryBillList()" :class="item.code == specialId ? '' : 'yanse'" v-for="item in specialColumn" :key="item.code">{{
            item.name
          }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div v-if="activeName == 'book'">
      <div style="display: flex; justify-content: space-between; align-items: center">
        <div>
          <el-cascader clearable v-model="classifyId" @change="queryBookList" placeholder="请选择图书所属分类" :options="options" :show-all-levels="false" size="small"></el-cascader>
          <el-select v-model="bookLevel" placeholder="请选择图书等级" clearable size="small">
            <el-option v-for="item in bookLevelList" :key="item.id" :label="item.name" :value="item.code"> </el-option>
          </el-select>
          <el-input v-model="bookName" clearable placeholder="请输入图书名称关键词" size="small" style="width: 200px"></el-input>
          <el-button type="primary" size="small" @click=";(curPage = 1), queryBookList()">搜索</el-button>
        </div>
        <div class="bhui">
          <el-button type="primary" size="small" @click="daoru">导入图书</el-button>
          <el-button type="primary" size="small" @click="daoru2">导入题库</el-button>
          <el-button type="primary" size="small" @click="xiznneg"><i class="el-icon-plus el-icon--left"></i>添加</el-button>
        </div>
      </div>
      <el-table :data="tableData" border stripe style="width: 100%" highlight-current-row ref="multipleTable">
        <el-table-column label="序号" align="center" type="index" width="55"> </el-table-column>
        <el-table-column label="封面" align="center" width="130">
          <template slot-scope="scope">
            <el-image style="width: 100px; height: 120px" :src="scope.row.bookImgUrl ? scope.row.serverHttp + scope.row.bookImgUrl : ''" fit="cover">
              <div slot="error" class="image-err">暂无封面</div></el-image
            >
          </template>
        </el-table-column>
        <el-table-column prop="bookName" label="名称" align="center"></el-table-column>
        <el-table-column prop="bookGradesName" label="适合年级" align="center"></el-table-column>
        <el-table-column prop="bookStarNumber" label="阅读分级（星星值）" align="center"></el-table-column>
        <el-table-column prop="bookAuthor" label="作者" align="center"> </el-table-column>
        <el-table-column prop="publishingName" label="出版社" align="center"></el-table-column>
        <el-table-column prop="bookCode" label="编号" align="center"></el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            {{ scope.row.publishStatus == 1 ? (scope.row.delistStatus == 1 ? '已上架' : '未上架') : '未发布' }}
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="150">
          <template slot-scope="scope">
            <!-- <el-button type="text" @click="bianji(scope.row)" v-if="schoolId==scope.row.schoolId">编辑</el-button>
            <el-button type="text" @click="toPublish(scope.row)" v-if="scope.row.publishStatus == 0">发布</el-button>
            <el-button type="text" @click="detailBook(scope.row)" v-if="scope.row.publishStatus == 1">详情</el-button>
            <el-button type="text" @click="modifyPublishStatus(scope.row)" v-if="scope.row.publishStatus == 1 && scope.row.delistStatus == 0">上架</el-button>
            <el-button type="text" @click="modifyPublishStatus(scope.row)" v-if="scope.row.delistStatus == 1">下架</el-button> -->
            <el-button type="text" @click="batchRemoveFromSchoolBooks(scope.row)" >移除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="text-align: right; padding: 10px"
        @prev-click="change"
        @next-click="change"
        :page-size="10"
        @current-change="change"
        background
        layout="total,prev, pager, next"
        :hide-on-single-page="true"
        :total="totalCount"
      ></el-pagination>
    </div>
    <div v-if="activeName == 'package'">
      <div style="display: flex; justify-content: space-between; align-items: center">
        <div>
          <el-input v-model="bookName" clearable placeholder="请输入系列名称关键词" size="small" style="width: 200px"></el-input>
          <el-button type="primary" size="small" @click=";(curPage = 1), queryBillList()">搜索</el-button>
        </div>
        <div class="bhui">
          <el-button type="primary" size="small" @click="xiznnegBill()"><i class="el-icon-plus el-icon--left"></i>添加</el-button>
        </div>
      </div>
      <el-table :data="tableData" border stripe style="width: 100%" highlight-current-row ref="package">
        <el-table-column label="序号" align="center" type="index" width="55"> </el-table-column>
        <el-table-column label="封面" align="center" width="130">
          <template slot-scope="scope">
            <el-image style="width: 100px; height: 120px" :src="scope.row.imgUrl ? scope.row.serverHttp + scope.row.imgUrl : ''" fit="cover">
              <div slot="error" class="image-err">暂无封面</div></el-image
            >
          </template>
        </el-table-column>
        <el-table-column prop="billName" label="名称" align="center"></el-table-column>
        <el-table-column prop="billGradesName" label="适合年级" align="center"></el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            {{ scope.row.publishStatus == 1 ? (scope.row.delistStatus == 1 ? '已上架' : '未上架') : '未发布' }}
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="150">
          <template slot-scope="scope">
            <el-button type="text" @click="bianjiBill(scope.row)" v-if="scope.row.publishStatus == 0">编辑</el-button>
            <el-button type="text" @click="modifyBillPublishStatus(scope.row)" v-if="scope.row.publishStatus == 0">发布</el-button>
            <el-button type="text" @click="detailBill(scope.row)" v-if="scope.row.publishStatus == 1">详情</el-button>
            <el-button type="text" @click="modifyBillPublishStatus(scope.row)" v-if="scope.row.publishStatus == 1 && scope.row.delistStatus == 0">上架</el-button>
            <el-button type="text" @click="modifyBillPublishStatus(scope.row)" v-if="scope.row.delistStatus == 1">下架</el-button>
            <el-button type="text" @click="delBill(scope.row)" v-if="scope.row.publishStatus == 0">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="text-align: right; padding: 10px"
        @prev-click="change2"
        @next-click="change2"
        :page-size="10"
        @current-change="change2"
        background
        layout="total,prev, pager, next"
        :hide-on-single-page="true"
        :total="totalCount"
      ></el-pagination>
    </div>
    <el-dialog :modal-append-to-body="false" :title="activeName == 'book' ? '图书详情' : '书单详情'" :visible.sync="dialogVisible" width="60vw">
      <el-descriptions :column="1">
        <el-descriptions-item label="名称">{{ activeName == 'book' ? seeItem.bookName : seeItem.billName }}</el-descriptions-item>
        <el-descriptions-item label="封面"
          ><img style="width: 200px; height: 240px" :src="activeName == 'book' ? seeItem.serverHttp + seeItem.bookImgUrl : seeItem.serverHttp + seeItem.imgUrl"
        /></el-descriptions-item>
        <el-descriptions-item label="适合年级">{{ activeName == 'book' ? seeItem.bookGradesName : seeItem.billGradesName }}</el-descriptions-item>
        <el-descriptions-item label="图书分类" v-if="activeName == 'book' && seeItem.readClassifyBookList.length > 0">{{ seeItem.readClassifyBookList[0].classifyName }}</el-descriptions-item>
        <el-descriptions-item label="所属专栏">{{ getNameById(seeItem.specialColumn, specialColumn, 'code', 'name') }}</el-descriptions-item>
        <el-descriptions-item label="阅读分级(星星值)" v-if="activeName == 'book'">
          <span style="margin-right: 5px">开始阅读星星值 {{ seeItem.starRuleObj.startReadNumber }}颗</span>
          <span style="margin-right: 5px">结束阅读星星值 {{ seeItem.starRuleObj.endReadNumber }}颗</span>
          <span style="margin-right: 5px">提交读后感星星值 {{ seeItem.starRuleObj.summitFeelNumber }}颗</span>
          <span style="margin-right: 5px">完成测评星星值 {{ seeItem.starRuleObj.complatePaperNumber }}颗</span>
        </el-descriptions-item>
        <el-descriptions-item label="作者" v-if="activeName == 'book'">{{ seeItem.bookAuthor }}</el-descriptions-item>
        <el-descriptions-item label="出版社" v-if="activeName == 'book'">{{ seeItem.publishingName }}</el-descriptions-item>
        <el-descriptions-item label="编号" v-if="activeName == 'book'">{{ seeItem.bookCode }}</el-descriptions-item>
        <el-descriptions-item label="图书字数" v-if="activeName == 'book'">{{ seeItem.wordNumber }}</el-descriptions-item>
        <el-descriptions-item label="简介"><div class="richText" v-html="activeName == 'book' ? seeItem.bookIntro : seeItem.billIntro"></div></el-descriptions-item>
        <el-descriptions-item label="系列图书" v-if="activeName == 'package'">
          <el-table :data="seeItem.readBooksList" border stripe highlight-current-row ref="table" :header-cell-style="{ height: '40px', padding: 0 }">
            <el-table-column label="序号" align="center" type="index" width="55"> </el-table-column>
            <el-table-column label="封面" align="center" width="130">
              <template slot-scope="scope">
                <el-image style="width: 100px; height: 100px" :src="scope.row.bookImgUrl ? scope.row.serverHttp + scope.row.bookImgUrl : ''" fit="cover">
                  <div slot="error" class="image-err">暂无封面</div></el-image
                >
              </template>
            </el-table-column>
            <el-table-column prop="bookName" label="名称" align="center"></el-table-column>
            <el-table-column prop="bookGradesName" label="适合年级" align="center"></el-table-column>
            <el-table-column prop="bookStarNumber" label="阅读分级（星星值）" align="center" width="85"></el-table-column>
            <el-table-column prop="bookAuthor" label="作者" align="center"> </el-table-column>
            <el-table-column prop="publishingName" label="出版社" align="center"></el-table-column>
            <el-table-column prop="bookCode" label="编号" align="center"></el-table-column>
          </el-table>
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
    <el-dialog title="导入图书" :modal-append-to-body="false" :visible.sync="dialogVisible1" width="30%" style="text-align: left" :before-close="importClose">
      <div>
        1、请先下载模板
        <el-button style="float: right" type="text" @click="exportReadBookTemplate">下载模板</el-button>
      </div>
      <div style="margin: 10px 0">2、模板填写完成上传提交</div>
      <el-upload
        :limit="1"
        :on-exceed="onExceed"
        :on-success="chengg"
        :on-error="chengg1"
        :on-progress="shangchausjffas"
        class="upload-demo"
        ref="upload"
        :headers="headers"
        :action="urlsyrl()"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :file-list="fileList"
        :auto-upload="false"
      >
        <el-button slot="trigger" size="small" type="primary">导入图书</el-button>
      </el-upload>
      <div style="margin-top: 5px; color: red">
        注意事项：<br />
        1、红色字的表头为必填项，不填写将会导致图书导入失败<br />
        2、图书分类、所属专栏、出版社为下拉选择，手动输入无效<br />
        3、适合年级可以填多个，使用逗号“,”分隔
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            dialogVisible1 = false
            fileList = []
          "
          size="small"
          >取 消</el-button
        >
        <el-button type="primary" @click="submitUpload" size="small">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="导入题库" :modal-append-to-body="false" :visible.sync="dialogVisible4" width="30%" style="text-align: left" :before-close="importClose">
      <div>
        1、请先下载模板
        <el-link
          style="float: right"
          :underline="false"
          type="primary"
          href="https://file.jingshidata.com/temp/import/%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E5%9B%BE%E4%B9%A6%E9%A2%98%E5%BA%93%E6%A8%A1%E6%9D%BF2023.xlsx"
          >下载模板</el-link
        >
      </div>
      <div style="margin: 10px 0">2、模板填写完成上传提交</div>
      <el-upload
        :limit="1"
        :on-exceed="onExceed"
        :on-success="chengg"
        :on-error="chengg1"
        :on-progress="shangchausjffas"
        class="upload-demo"
        ref="upload2"
        :headers="headers"
        :action="urlsyrl2()"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :file-list="fileList"
        :auto-upload="false"
      >
        <el-button slot="trigger" size="small" type="primary">导入题库</el-button>
      </el-upload>
      <div style="margin-top: 5px; color: red">
        注意事项：<br />
        1、难易程度、类型、题干、选项（至少两项，最多六项）<br />
        2、难易程度、类型是下拉选择，手动输入无效<br />
        3、正确答案一栏必须是大写字母，多选题用英文逗号“,”分割<br />
        4、红色字体为必填项
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            dialogVisible4 = false
            fileList = []
          "
          size="small"
          >取 消</el-button
        >
        <el-button type="primary" @click="submitUpload2" size="small">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :modal-append-to-body="false"
      class="youcedigao"
      top="100px"
      :modal="false"
      title="导入结果"
      :visible.sync="dialogVisible3"
      width="30%"
      style="text-align: left"
      :before-close="clearDats"
    >
      <el-row id="ID">
        <el-col :span="24" style="font-weight: bold; margin-bottom: 10px"> 成功信息 </el-col>
        <el-col :span="24"> 成功导入 {{ dats.scount }} 条 </el-col>
        <el-col :span="24" style="font-weight: bold; margin-top: 10px"> 失败信息 </el-col>
        <el-col :span="24">
          <el-table :data="dats.errorMsgs" border stripe style="width: 100%; margin-top: 15px" highlight-current-row>
            <el-table-column prop="row" label="错误行数" align="center" width="100"></el-table-column>
            <el-table-column prop="msg" label="错误信息" align="center"></el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import * as homeApi from '@/api/home'
import { ERR_OK, BASE_URL } from '@/api/index'
export default {
  name: 'read',
  data() {
    return {
      headers: {
        token: '' //文件上传请求头
      },
      fileList: [],
      dats: {},
      activeName: 'book',
      loading: false,
      courselist: [],
      totalCount: 0,
      bookName: '',
      specialColumn: [],
      specialId: '',
      gradelist: [],
      gradeId: '',
      tableData: [],
      publishStatus: '',
      classifyId: [],
      seeItem: {
        starRuleObj: {},
        readClassifyBookList: []
      },
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      schoolId: '',
      bookLevelList: [],
      bookLevel: '',
      curPage:1,
      options: [], //图书分类
      bookSourceType:0
    }
  },
  activated() {
    switch (this.activeName) {
      case 'book':
        this.queryBookList()
        break
      case 'package':
        this.queryBillList()
        break
      default:
        break
    }
  },
  created() {
    this.stage = JSON.parse(localStorage.getItem('info')).schoolId
    this.schoolId = JSON.parse(localStorage.getItem('info')).schoolId
    this.headers.token = localStorage.getItem('token')
    this.dictcode()
    this.dictcode1()
    this.gradegradelist()
    this.getTreeReadClassify()
    // this.queryBookList()
  },
  watch: {
    bookLevel(v) {
      this.queryBookList()
    },
    activeName(v) {
      this.bookName = ''
      this.specialId = ''
      this.gradeId = ''
      this.publishStatus = ''
      this.classifyId = []
      this.curPage = 1
      switch (v) {
        case 'book':
          this.queryBookList()
          break
        case 'package':
          this.queryBillList()
          break
        default:
          break
      }
    }
  },
  methods: {
    onExceed() {
      this.$message.error('一次只能上传一个文件!')
    },
    exportReadBookTemplate() {
      homeApi.exportReadBookTemplate()
    },
    clearDats(done) {
      this.dats = {}
      done()
    },
    importClose(done) {
      this.fileList = []
      done()
    },
    shangchausjffas() {
      this.loading = true
    },
    handleRemove(file, fileList) {},
    handlePreview(file) {},
    submitUpload() {
      this.$refs.upload.submit()
    },
    submitUpload2() {
      this.$refs.upload2.submit()
    },
    urlsyrl() {
      return BASE_URL + '/read/import/importBooK'
    },
    urlsyrl2() {
      return BASE_URL + '/read/import/importQuestion'
    },
    chengg(data) {
      this.loading = false
      this.dialogVisible1 = false
      this.dialogVisible4 = false
      this.fileList = []
      this.queryBookList()
      if (data.code == 0) {
        this.dats = data.data
        this.dialogVisible3 = true
        this.$message({
          message: '上传成功',
          type: 'success'
        })
      } else {
        this.$message({
          message: '上传失败',
          type: 'success'
        })
        this.$message(data.msg)
      }
    },
    chengg1() {
      this.loading = false
      this.$message('上传失败')
    },
    daoru() {
      this.dialogVisible1 = true
    },
    daoru2() {
      this.dialogVisible4 = true
    },
    modifyBillPublishStatus(item) {
      if (item.publishStatus == 0) {
        let params = {
          publishStatus: 1,
          id: item.id
        }
        homeApi
          .modifyBillPublishStatus(params)
          .then((res) => {
            if (res.data.code == 0) {
              this.$message.success('操作成功')
              this.queryBillList()
            }
          })
          .catch(() => {})
      } else {
        let params = {
          delistStatus: item.delistStatus == 0 ? 1 : 0,
          id: item.id
        }
        homeApi
          .modifyBillDelistStatus(params)
          .then((res) => {
            if (res.data.code == 0) {
              this.$message.success('操作成功')
              this.queryBillList()
            }
          })
          .catch(() => {})
      }
    },
    batchRemoveFromSchoolBooks(s){
      this.$confirm('是否确定移除书籍吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
                .then(() => {
                  let params = {
                    bookIds:s.id,
                  }
                  homeApi
                    .batchRemoveFromSchoolBooks(params)
                    .then((res) => {
                      if (res.data.code == 0) {
                        this.$message.success('移除成功')
                        this.queryBookList()
                      }
                    })
                    .catch(() => {})
                })
                .catch(() => {})
    },
    toPublish(item) {
      let params = {
        bookId: item.id
      }
      homeApi
        .getResourceByBookId(params)
        .then((res) => {
          if (res.data.code == 0) {
            if (res.data.data.length == 0 || !item.paperRule) {
              this.$confirm('该书没有配套资源或测评设置，确认发布吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
                .then(() => {
                  let params = {
                    publishStatus: 1,
                    id: item.id
                  }
                  homeApi
                    .modifyPublishStatus(params)
                    .then((res) => {
                      if (res.data.code == 0) {
                        this.$message.success('发布成功')
                        this.queryBookList()
                      }
                    })
                    .catch(() => {})
                })
                .catch(() => {})
            } else {
              this.$confirm('发布后无法撤回，确认发布吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
                .then(() => {
                  let params = {
                    publishStatus: 1,
                    id: item.id
                  }
                  homeApi
                    .modifyPublishStatus(params)
                    .then((res) => {
                      if (res.data.code == 0) {
                        this.$message.success('发布成功')
                        this.queryBookList()
                      }
                    })
                    .catch(() => {})
                })
                .catch(() => {})
            }
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    modifyPublishStatus(item) {
      if (item.publishStatus == 0) {
        let params = {
          publishStatus: 1,
          id: item.id
        }
        homeApi
          .modifyPublishStatus(params)
          .then((res) => {
            if (res.data.code == 0) {
              this.$message.success('操作成功')
              this.queryBookList()
            }
          })
          .catch(() => {})
      } else {
        let params = {
          delistStatus: item.delistStatus == 0 ? 1 : 0,
          id: item.id
        }
        homeApi
          .modifyDelistStatus(params)
          .then((res) => {
            if (res.data.code == 0) {
              this.$message.success('操作成功')
              this.queryBookList()
            }
          })
          .catch(() => {})
      }
    },
    getTreeReadClassify() {
      let that = this
      let params = {
        schoolId: -1
      }
      homeApi
        .getTreeReadClassify(params)
        .then((res) => {
          res.data.data = that.xunahj(res.data.data)
          that.options = res.data.data
        })
        .catch(() => {})
    },
    xunahj(s) {
      s.forEach((item) => {
        item.value = item.id
        item.label = item.classifyName
        if (item.chilrenList && item.chilrenList.length > 0) {
          item.children = item.chilrenList
          this.xunahj(item.children)
        }
      })
      return s
    },
    //年级列表
    getGradeStage() {
      let that = this
      homeApi
        .getGradeStage({
          stage: 5
        })
        .then((res) => {
          that.gradelist = res.data.data
        })
    },
    gradegradelist() {
      let params = {
        schoolId: this.schoolId
      }
      homeApi
        .gradegradelist(params)
        .then((res) => {
          this.gradelist = res.data.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getNameById(id, targetList, idName, name) {
      let result = '暂无'
      let index = targetList.findIndex((i) => {
        return i[idName] == id
      })
      if (index != -1) {
        result = targetList[index][name]
      }
      return result
    },
    dictcode1() {
      let that = this
      homeApi
        .dictcode({
          code: 'book_level'
        })
        .then((res) => {
          that.bookLevelList = res.data.data
        })
    },
    dictcode() {
      let that = this
      homeApi
        .dictcode({
          code: 'special_column'
        })
        .then((res) => {
          that.specialColumn = res.data.data
        })
    },
    bianji(s) {
      this.$router.push({
        path: '/readBook',
        query: {
          id: s.id
        }
      })
    },
    xiznneg() {
      this.$router.push({
        path: '/readBook'
      })
    },
    detailBook(s) {
      this.$router.push({
        path: '/readBook',
        query: {
          id: s.id,
          modeType: 'detail'
        }
      })
    },
    detailBill(s) {
      this.$router.push({
        path: '/readBill',
        query: {
          id: s.id,
          modeType: 'detail'
        }
      })
    },
    bianjiBill(s) {
      this.$router.push({
        path: '/readBill',
        query: {
          id: s.id
        }
      })
    },
    xiznnegBill() {
      this.$router.push({
        path: '/readBill'
      })
    },
    delBill(s) {
      this.$confirm('是否删除此书单，删除后无法恢复！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let that = this
          let params = {
            id: s.id
          }
          homeApi
            .delBill(params)
            .then((res) => {
              that.$message({
                type: 'success',
                message: '操作成功!'
              })
              that.queryBillList()
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    delBook(s) {
      this.$confirm('是否删除此书籍，删除后无法恢复！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let that = this
          let params = {
            id: s.id
          }
          homeApi
            .delBook(params)
            .then((res) => {
              that.$message({
                type: 'success',
                message: '操作成功!'
              })
              that.queryBookList()
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    change(s) {
      this.curPage = s
      this.queryBookList()
    },
    change2(s) {
      this.curPage = s
      this.queryBillList()
    },
    queryBillList() {
      let that = this
      this.loading = true
      // console.log(this.leafClassifyId)
      let params = {
        schoolId: this.schoolId,
        pageNum: this.curPage,
        pageSize: 10,
        billName: this.bookName,
        publishStatus: this.publishStatus.toString(),
        bookGrades: this.gradeId.toString(),
        specialColumn: this.specialId.toString(),
      }
      homeApi
        .queryBillList(params)
        .then((res) => {
          that.tableData = res.data.data.dataList
          that.totalCount = res.data.data.totalCount
          that.loading = false
        })
        .catch(() => {
          that.loading = false
        })
    },
    queryBookList() {
      let that = this
      this.loading = true
      // console.log(this.leafClassifyId)
      let params = {
        schoolId: this.schoolId,
        pageNum: this.curPage,
        pageSize: 10,
        bookName: this.bookName,
        bookLevel: this.bookLevel,
        publishStatus: this.publishStatus.toString(),
        classifyId: this.classifyId.length > 0 ? this.classifyId[this.classifyId.length - 1].toString() : '',
        bookGrades: this.gradeId.toString(),
        specialColumn: this.specialId.toString(),
        bookSourceType:this.bookSourceType
      }
      homeApi
        .queryBookList(params)
        .then((res) => {
          that.tableData = res.data.data.dataList
          that.totalCount = res.data.data.totalCount
          that.loading = false
        })
        .catch(() => {
          that.loading = false
        })
    },
    dictcode2() {
      let that = this
      homeApi
        .dictcode({
          code: 'course_limit'
        })
        .then((res) => {
          that.courselist = res.data.data
        })
    }
  }
}
</script>

<style lang="less" scoped>
.yanse {
  color: #999;
}
.bhui {
  // background-color: #eee;
  padding: 10px;
  margin: 10px 0;
}
.nhufa {
  padding-top: 15px;
}
.el-radio {
  margin-bottom: 15px;
}
.ifra {
  min-height: 800px;
}
.el-tag {
  margin-right: 10px;
}
.magf {
  margin: 15px 0;
}
.courseNames::after {
  content: ',';
}
.courseNames:last-child::after {
  content: '';
}
.pcourseNames::after {
  content: ',';
}
.pcourseNames:last-child::after {
  content: '';
}
.el-radio {
  margin-bottom: 0px;
}
/deep/.image-err {
  height: 100px;
  line-height: 100px;
}
.el-form-item {
  margin-bottom: 0px;
}
.xuanhjifas {
  padding: 10px 20px;
  cursor: pointer;
}
.xuanhjifas:hover {
  border-color: #b3d8ff;
  color: #409eff;
  background: #ecf5ff;
}
.xuanhjjssss {
  border-color: #b3d8ff;
  color: #fff;
  background: #409eff;
}
.richText /deep/ img {
  max-width: 100% !important;
}
.cell .el-button {
  padding: 0;
}
.youcedigao /deep/ .el-dialog {
  margin: 0 40px 50px 0;
  float: right;
}
</style>


// WEBPACK FOOTER //
// src/components/read/index.vue